import { request } from "../api/client";
import { parseFinanceDelegations, parseFinanceMembers, parseFinancePage } from "./contracts";

const query = (partyId: string) => "?partyId=" + encodeURIComponent(partyId);
function nextPage(cursor: string | null | undefined, seen: Set<string>, count: number): string | null {
  if (count > 1000 || cursor && seen.has(cursor)) throw new Error("Finance list is too large or has an invalid cursor");
  if (cursor) seen.add(cursor);
  return cursor || null;
}
export async function loadFinanceSettings(partyId: string, signal: AbortSignal, includeTaxOptions = true) {
  const path = "/finance/settings" + query(partyId);
  const result = parseFinancePage(await request(path, "GET", undefined, signal), partyId);
  if (!includeTaxOptions) return result;
  const seen = new Set<string>(); let cursor = nextPage(result.taxAuthorityNextCursor, seen, result.taxAuthorityOptions.length);
  while (cursor) {
    const page = parseFinancePage(await request(path + "&taxAuthorityCursor=" + encodeURIComponent(cursor), "GET", undefined, signal), partyId);
    if (page.version !== result.version || page.capabilities.join(",") !== result.capabilities.join(",")) throw new Error("Finance settings changed during loading");
    result.taxAuthorityOptions.push(...page.taxAuthorityOptions);
    if (new Set(result.taxAuthorityOptions.map(item => item.taxAuthId)).size !== result.taxAuthorityOptions.length) throw new Error("Duplicate tax authority options");
    cursor = nextPage(page.taxAuthorityNextCursor, seen, result.taxAuthorityOptions.length);
  }
  return result;
}
export async function loadFinanceDelegations(partyId: string, signal: AbortSignal) {
  const path = "/finance/delegations" + query(partyId);
  const result = parseFinanceDelegations(await request(path, "GET", undefined, signal));
  const seen = new Set<string>(); let cursor = nextPage(result.nextCursor, seen, result.items.length);
  while (cursor) {
    const page = parseFinanceDelegations(await request(path + "&cursor=" + encodeURIComponent(cursor), "GET", undefined, signal));
    result.items.push(...page.items);
    if (new Set(result.items.map(item => item.userId)).size !== result.items.length) throw new Error("Duplicate finance delegations");
    cursor = nextPage(page.nextCursor, seen, result.items.length);
  }
  seen.clear(); cursor = nextPage(result.candidatesNextCursor, seen, result.candidates.length);
  while (cursor) {
    const page = parseFinanceMembers(await request("/finance/members" + query(partyId) + "&cursor=" + encodeURIComponent(cursor), "GET", undefined, signal));
    result.candidates.push(...page.items);
    if (new Set(result.candidates.map(item => item.userId)).size !== result.candidates.length) throw new Error("Duplicate finance candidates");
    cursor = nextPage(page.nextCursor, seen, result.candidates.length);
  }
  return result;
}
